import { Input, Switch, Radio, Select } from 'antd'
import BigNumber from 'bignumber.js'
import Numeral from 'numeral'
import type { ChangeEvent } from 'react'
import { useMemo, useState } from 'react'

import DataLoading from '@/assets/data-loading.png'
import CardPart from '@/components/PosCard'
import { useLocalStorage } from '@/context/localstorage-context'

import {
  FilterArea,
  Header,
  Main,
  MainArea,
  MyDele1,
  MyDele2,
  Part,
  PartMedia,
  Title,
} from './Pos.module'

const { Search } = Input

const TYPE: Record<string, string> = {
  '0': 'TVL',
  '1': 'Fee Rate',
  '2': 'Activity',
  '3': 'Quota',
}

export default function PosLists({ stakerList }: { stakerList: any }) {
  const [sortedBy, setSortedBy] = useState('0')
  const [searchName, setSearchName] = useState('')
  const { theme, posSwitchOn, setPosSwitchOn } = useLocalStorage()

  const isDark = useMemo(() => theme === 'dark', [theme])

  const onChange = (data: ChangeEvent<HTMLInputElement>) =>
    setSearchName(data.target.value)

  const sortFunc = (stakerList: any, type: string) => {
    switch (type) {
      case '0':
        return stakerList.sort(
          // @ts-ignore
          (a, b) =>
            // @ts-ignore
            Numeral(b.totalAmountFmt).value() -
            // @ts-ignore
            Numeral(a.totalAmountFmt).value(),
        )
      case '1':
        return stakerList.sort(
          // @ts-ignore
          (a, b) =>
            // @ts-ignore
            Numeral(a.feeRateFmt).value() - Numeral(b.feeRateFmt).value(),
        )
      case '2':
        return stakerList.sort(
          // @ts-ignore
          (a, b) => Numeral(b.activity).value() - Numeral(a.activity).value(),
        )
      case '3':
        return stakerList.sort(
          // @ts-ignore
          (a, b) => Numeral(b.quotaLeft).value() - Numeral(a.quotaLeft).value(),
        )
    }
  }

  const setActivityZeroEnd = (stakerList: any) => {
    const activityZeroArr = stakerList.filter(
      (v: any) => (Numeral(v.activity).value() || '0') === '0',
    )
    const activityNotZeroArr = stakerList.filter(
      (v: any) => (Numeral(v.activity).value() || '0') !== '0',
    )
    return activityNotZeroArr.concat(activityZeroArr)
  }

  const stakerListByFilter = useMemo(() => {
    let tmp: any
    if (posSwitchOn) {
      tmp = stakerList.filter((v: any) => new BigNumber(v.myDelegate).gt('0'))
    } else {
      tmp = stakerList
    }
    const tmp1 = setActivityZeroEnd(sortFunc(tmp, sortedBy))
    return tmp1.filter(
      (v: any) =>
        searchName === '' ||
        v.name.toLowerCase().includes(searchName.toLowerCase()),
    )
  }, [posSwitchOn, sortedBy, stakerList, searchName])

  const isLoading = useMemo(
    () => !(stakerList && stakerList.length > 0),
    [stakerList],
  )

  const handleSwitch = (checked: boolean) => {
    setPosSwitchOn(checked)
    window.localStorage.posSwitchOn = checked
  }

  return (
    <Main>
      <Header isDark={isDark}>
        <Title className="text-light-0 dark:text-dark-111">PoS Nodes</Title>
        <Search
          placeholder="Search Names"
          onChange={onChange}
          style={{ width: 200 }}
        />
      </Header>
      <FilterArea isDark={isDark}>
        <Part isDark={isDark}>
          <MyDele1 className="text-light-0 dark:text-dark-0">
            My Delegations
          </MyDele1>
          <Switch
            checked={posSwitchOn}
            onChange={handleSwitch}
            size="small"
            className="bg-light-777 dark:bg-dark-444"
          />
        </Part>
        <Part isDark={isDark} className="part">
          <MyDele2 className="text-light-0 dark:text-dark-0">
            Sorted by:
          </MyDele2>
          <Radio.Group
            value={sortedBy}
            onChange={(e) => setSortedBy(e.target.value)}
          >
            {Object.keys(TYPE).map((v: string) => (
              <Radio.Button key={v} value={v} onClick={() => setSortedBy(v)}>
                {TYPE[v]}
              </Radio.Button>
            ))}
          </Radio.Group>
        </Part>
        <PartMedia isDark={isDark}>
          <Select
            popupClassName={isDark ? 'dark-select' : 'light-select'}
            showArrow={false}
            defaultValue={TYPE[0]}
            style={{ width: 120 }}
            getPopupContainer={(triggerNode) =>
              triggerNode.parentNode as HTMLElement
            }
            onSelect={(v) => setSortedBy(v)}
            options={Object.keys(TYPE).map((v) => ({
              value: v,
              label: TYPE[v],
            }))}
          />
        </PartMedia>
      </FilterArea>
      <MainArea $loading={isLoading}>
        {isLoading ? (
          <img src={DataLoading} alt="loading" width={150} />
        ) : (
          stakerListByFilter.map((staker: any, index: number) => (
            <CardPart staker={staker} key={index} />
          ))
        )}
      </MainArea>
    </Main>
  )
}
